import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

export enum UserCreateMode {
    AddMe = 'AddMe',
    CreateNew = 'CreateNew',
}

export class NewAirswebInstanceModel {
    UserCreateMode: UserCreateMode;
    UserName: string;
    Password: string;
    FirstName: string;
    LastName: string;
    Email: string;
    TenantId: string;
    ClientId: string;
    EnvironmentId: number;
    IsEcoIdTenant: boolean;
}
@Injectable({
    providedIn: 'root',
})
export class
AirswebInstanceService {
    constructor(private http: HttpClient) {
    }

    provisionNew(model: NewAirswebInstanceModel) {
        return this.http.post<string>("/api/airsweb/provision", model).pipe(map(r => r));
    }
}